module.exports = __webpack_public_path__ + "img/heyteam-logo.2d51971e.png";